export default defineNuxtPlugin(nuxtApp => {
    // @ts-expect-error we know $i18n is available
    nuxtApp.$i18n.baseUrl = useRequestURL().origin
})
